<wbo-search-page>
    <wbo-search-grid>
        <wbo-main-search-column field="tableName"></wbo-main-search-column>
        <wbo-column field="location"></wbo-column>
        <wbo-column field="serviceArea"></wbo-column>
        <wbo-column field="code"></wbo-column>
        <wbo-column field="discount"></wbo-column>
        <wbo-currency-column field="spendLimit"></wbo-currency-column>
    </wbo-search-grid>
</wbo-search-page>
